var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconInternational48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18952)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 42.5029C33.9411 42.5029 42 34.4441 42 24.5029C42 14.5618 33.9411 6.50293 24 6.50293C14.0589 6.50293 6 14.5618 6 24.5029C6 34.4441 14.0589 42.5029 24 42.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_18952",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 36,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42.5029C33.9411 42.5029 42 34.4441 42 24.5029C42 14.5618 33.9411 6.50293 24 6.50293C14.0589 6.50293 6 14.5618 6 24.5029C6 34.4441 14.0589 42.5029 24 42.5029Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_18952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 42.5029C33.9411 42.5029 42 34.4441 42 24.5029C42 14.5618 33.9411 6.50293 24 6.50293C14.0589 6.50293 6 14.5618 6 24.5029C6 34.4441 14.0589 42.5029 24 42.5029Z",
    stroke: "#918F90",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8972 5.57983C25.4 7.01442 24.1295 8.81939 24.0855 10.9947C24.0196 14.2578 28.2862 12.5043 28.2862 14.8606C28.2862 17.2168 25.5048 17.6517 23.0023 15.2564C20.4998 12.861 17.7271 12.5904 15.2416 14.7316C12.756 16.8729 12.3477 22.5063 16.6287 23.3784C20.9097 24.2505 21.5338 24.5903 21.5338 28.9238C21.5338 33.2573 22.0974 34.1952 25.4533 34.1952C28.8092 34.1952 27.0153 30.6902 28.2862 28.4198C29.5571 26.1494 31.7535 24.9644 31.7535 23.1186C31.7535 21.2727 27.4903 21.5919 28.2862 19.0151C29.0821 16.4384 32.8589 17.835 34.69 16.7586C36.5211 15.6822 37.7735 11.452 37.2736 10.9947C37.0429 10.7837 36.2173 9.58783 33.6853 8.04348C32.7736 7.48745 32.0731 6.77459 30.9631 6.41957C30.1121 6.07674 29.0901 5.79683 27.8972 5.57983Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 42.5029C33.9411 42.5029 42 34.4441 42 24.5029C42 14.5618 33.9411 6.50293 24 6.50293C14.0589 6.50293 6 14.5618 6 24.5029C6 34.4441 14.0589 42.5029 24 42.5029Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconInternational48);
export default __webpack_public_path__ + "static/media/pictogramBeaconInternational48.7ff4634c04960a833d6972b295969f70.svg";
export { ForwardRef as ReactComponent };